
import { memo, useCallback, useState } from 'react';
import { useAsync } from 'react-use';
import { IPlayer, ITeam } from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import { useModal } from '@zmedia/bm-soccer-ui/hooks';
import TournamentService from '@zmedia/bm-soccer-ui/service/TournamentService';
import {
    Columns,
    Element,
    Icon,
    Section,
} from '@zmedia/bm-soccer-ui/components';
import Empty from '@zmedia/bm-soccer-ui/modules/shared/components/Empty';
import { ModalStatsPlayer, StatsPlayer } from './components';
import styles from './style.module.scss';

export interface IRankingPlayer {
    id: number;
    player: IPlayer;
    team: ITeam;
    value: string;
    extra: string;
}

export interface IRankType {
    id: number;
    name: string;
}
export interface IRankingPlayerList {
    items: IRankingPlayer[];
    type: IRankType;
}

export function TournamentStatistic(props: any) {
    const { id, seasonId } = props;

    const { Modal, show, hide } = useModal();
    const [type, setType] = useState<IRankType>({
        id: 0,
        name: '',
    });

    let items = props.items || [];
    if (ArrayUtils.isEmpty(items)) {
        const state = useAsync(
            () =>
                TournamentService.getRankingList({
                    seasonId: seasonId,
                    tournamentId: id,
                }),
            [seasonId, id]
        );
        const data = state.value?.data || {};
        items =
            data?.items?.filter((item: IRankingPlayerList) => {
                return !ArrayUtils.isEmpty(item.items || []);
            }) || [];
    }

    const handleClick = (type: IRankType) => {
        show();
        setType(type);
    };

    const renderStat = (item: IRankingPlayerList, index: number) => {
        return (
            <Columns.Column key={index}>
                <Element className={styles['stats-container']}>
                    <Element
                        renderAs="h3"
                        className={styles['title']}
                        onClick={() => handleClick(item.type)}
                    >
                        {item.type.name}
                        <Icon icon="forward-2" />
                    </Element>
                    <StatsPlayer items={item.items} />
                </Element>
            </Columns.Column>
        );
    };

    const renderStats = useCallback((items: IRankingPlayerList[] = []) => {
        return items.map((item: IRankingPlayerList, index: number) => {
            return renderStat(item, index);
        });
    }, []);

    if (ArrayUtils.isEmpty(items)) {
        return (
            <Section>
                <Empty content="Chưa có thống kê nào"></Empty>
            </Section>
        );
    }

    return (
        <Columns className={styles['column-stats']}>
            {renderStats(items)}
            <Modal>
                <ModalStatsPlayer {...props} hide={hide} type={type} />
            </Modal>
        </Columns>
    );
}

export default memo(TournamentStatistic);
